/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A weight estimated from height that formulas associate with good health. It originated in medicine for dosing and is a rough guide, not a strict goal.`)
};

const es_iw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un peso estimado a partir de la altura que las fórmulas asocian con buena salud. Se originó en medicina para la dosificación y es una guía aproximada, no un objetivo estricto.`)
};

const de_iw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein anhand der Körpergröße geschätztes Gewicht, das Formeln mit guter Gesundheit verknüpfen. Es stammt ursprünglich aus der Medizin zur Dosierung und ist eine grobe Orientierung, kein striktes Ziel.`)
};

const nl_iw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een gewicht dat op basis van lengte wordt geschat en dat formules met een goede gezondheid associëren. Het komt oorspronkelijk uit de geneeskunde voor dosering en is een ruwe richtlijn, geen strikt doel.`)
};

const fr_iw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un poids estimé à partir de la taille que les formules associent à une bonne santé. Il vient de la médecine, pour le dosage, et c'est un guide approximatif, pas un objectif strict.`)
};

const it_iw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un peso stimato dall'altezza che le formule associano a una buona salute. Nasce in medicina per il dosaggio dei farmaci ed è un'indicazione generale, non un obiettivo rigido.`)
};

const pt_br2_iw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um peso estimado a partir da altura que as fórmulas associam a boa saúde. Ele surgiu na medicina para dosagem e é uma referência aproximada, não uma meta rígida.`)
};

const pt_iw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um peso estimado a partir da altura que as fórmulas associam a uma boa saúde. Teve origem na medicina para a dosagem de medicamentos e é uma referência geral, não um objetivo rígido.`)
};

const ja_iw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`計算式によって健康と関連付けられる、身長から推定された体重です。もともと医療分野の投与量算出に由来し、厳密な目標ではなく大まかな目安です。`)
};

const zh_iw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据身高估算出的、公式认为与良好健康相关的体重。它起源于医学上的药物剂量计算，只是粗略参考，而非严格目标。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_faq_a1", locale)
	if (locale === "en") return en_iw_faq_a1(inputs)
	if (locale === "es") return es_iw_faq_a1(inputs)
	if (locale === "de") return de_iw_faq_a1(inputs)
	if (locale === "nl") return nl_iw_faq_a1(inputs)
	if (locale === "fr") return fr_iw_faq_a1(inputs)
	if (locale === "it") return it_iw_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_iw_faq_a1(inputs)
	if (locale === "pt") return pt_iw_faq_a1(inputs)
	if (locale === "ja") return ja_iw_faq_a1(inputs)
	return zh_iw_faq_a1(inputs)
};